var _path, _path2, _path3;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgKnLogo = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 6a6 6 0 016-6h8a6 6 0 016 6v8a6 6 0 01-6 6H0V6z",
  fill: "#36D399"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 7a4 4 0 014-4h6a4 4 0 014 4v6a4 4 0 01-4 4H7a4 4 0 01-4-4V7z",
  fill: "#36D399"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.557 14.813l.943-.923-4.514-4.416 3.439-3.364-.943-.923-3.649 3.57v-3.57H6.5v8.287h1.333v-2.872l.211-.207 4.513 4.418z",
  fill: "#fff"
})));
export default SvgKnLogo;